import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/** SPA navigations land scrolled to top (browser default only covers loads). */
export function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}
